import { SnomedConceptTypeEnum, type SearchConceptDocumentationViewModel } from '@generated';
import { useSearch } from '~/util/http/useSearch';

interface useFindingsResult {
	isLoading: boolean;
	findings: string[];
}

export function useFindings(stayId: string): useFindingsResult {
	const { data, isLoading } = useSearch({
		searchType: 'concept-documentation',
		filters: [
			{
				name: 'stayId',
				operator: '==',
				value: stayId
			},
			{
				name: 'snomedConceptTypeId',
				operator: '==',
				value: SnomedConceptTypeEnum.Finding
			}
		]
	});

	return {
		isLoading,
		findings: data ? data.map((finding: SearchConceptDocumentationViewModel) => finding.conceptId) : []
	};
}
